/**
 * library list 相关
 */
import apis from 'src/const/apis';
import request from 'src/utils/request';

export default {
  namespaced: true,
  state: {
    hasPlayableMaterial: false,
  },
  mutations: {
    changeHasPlayableMaterial(state, data) {
      state.hasPlayableMaterial = data;
    },
  },
  actions: {
    getImageList(store, data) {
      return request.get(apis.library.image_list, data);
    },

    getVideoList(store, data) {
      return request.get(apis.library.video_list, data);
    },

    getPlayableList(store, data) {
      return request.get(apis.library.playable_list, data);
    },

    getNewPlayableList(store, data) {
      return request.get(apis.library.new_playable_list, data);
    },

    getNativeList(store, data) {
      return request.get(apis.library.native_list, data);
    },

    createNative(store, data) {
      return request.post(apis.library.native_create, data);
    },

    createPlayable(store, data) {
      return request.post(apis.library.playable_update_name, data);
    },

    deleteImage(store, data) {
      return request.post(apis.library.image_delete, data);
    },

    deleteVideo(store, data) {
      return request.post(apis.library.video_delete, data);
    },

    deletePlayable(store, data) {
      return request.post(apis.library.playable_delete, data);
    },

    updateImageName(store, data) {
      return request.post(apis.library.image_update_name, data);
    },

    updateVideoName(store, data) {
      return request.post(apis.library.video_update_name, data);
    },

    updatePlayableName(store, data) {
      return request.post(apis.library.playable_update_name, data);
    },
  },
};
